import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NombreDocumentosService {
  private apiUrl = `${environment.apiUrl}/api/nombre-documentos`;

  constructor(private http: HttpClient) { }

  createNombreDocumento(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  getAllNombreDocumentos(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getNombreDocumentoById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  updateNombreDocumento(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data);
  }

  inactivateNombreDocumento(id: number): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}/inactivate`, {});
  }

  deleteNombreDocumento(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
